import styled from 'styled-components';
import { DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';

export const StyledDropdownToggle = styled(DropdownToggle)`
  background: #ffffff;
  width: 180px;
  font-size: 12px;
  border: 1px solid #cccccc;
`;

export const StyledDropdownItem = styled(DropdownItem)`
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  justify-items: center;
  cursor: pointer;
  font-size: 14px;

  :hover {
    background: none;
    border: none;
    color: #33373d;
  }

  :active {
    background: none;
    border: none;
    color: #33373d;
  }
`;

export const StyledDropdownMenu = styled(DropdownMenu)`
  min-width: 250px;
  padding: 10px;
  max-height: 250px;
  overflow-y: scroll;
`;
